// extracted by mini-css-extract-plugin
export default {"root":"PageAuditTypes_root__tX4hi","top":"PageAuditTypes_top__rjPjS"};